import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { Facets } from '../../../common/schema/hannibal/types.generated';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

interface Props {
  values: Facets['paymentMethods'];
}

export const HicapsFilter = ({ values }: Props) => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const hasValue = filters.paymentMethod === 'HICAPS';

  const handleClick = () => {
    setFilters({
      ...filters,
      paymentMethod: hasValue ? undefined : 'HICAPS',
    });

    clear();
  };

  const shouldShow = hasValue || values?.some(it => it.term === 'HICAPS' && it.count !== 0);

  if (!shouldShow) return null;

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_HICAPS_BUTTON}
      onClick={handleClick}
      hasValue={hasValue}
    >
      HICAPS
    </FilterPill>
  );
};
